import { errorTextWithTraceId } from './errorText';

const UNEXPECTED_TEXT = 'Произошла непредвиденная ошибка. Попробуйте ещё раз.';

/**
 * Приводит произвольную ошибку (string | string[] | Error | объект с полем `message` | unknown)
 * к читаемой строке. Используется в `.catch`/`try…catch` модалок действий, где `setErrorText`
 * ожидает строку, а сервис может отклониться чем угодно.
 *
 * Разбор — канон `errorText` (сообщения интерцептора по строкам, тело и код ответа у AxiosError, HTML и фразы
 * статуса — не причина); свой здесь только запасной текст. Код обращения дописывается в конец отдельной строкой:
 * отдельного места под него в модалках нет.
 */
export const stringifyError = (error: unknown): string => errorTextWithTraceId(error, UNEXPECTED_TEXT, '\n');
